const COMPANY_VARIABLE = 'company'
const DEADLINE_VARIABLE = 'deadline'
const NAME_VARIABLE = 'name'
const URL_VARIABLE = 'url'
const CONTACT_EMAIL = 'contact_email'

const VARIABLES = {
  COMPANY_VARIABLE,
  DEADLINE_VARIABLE,
  NAME_VARIABLE,
  URL_VARIABLE,
  CONTACT_EMAIL,
}

export const getVariables = language => {
  const variables = [
    {
      key: VARIABLES.COMPANY_VARIABLE,
      label: { en: 'company', nb: 'firma' }[language],
    },
    {
      key: VARIABLES.DEADLINE_VARIABLE,
      label: { en: 'deadline', nb: 'frist' }[language],
    },
    {
      key: VARIABLES.NAME_VARIABLE,
      label: { en: 'full name', nb: 'fullt navn' }[language],
    },
    { key: VARIABLES.URL_VARIABLE, label: { en: 'url', nb: 'url' }[language] },
    {
      key: VARIABLES.CONTACT_EMAIL,
      label: { en: 'ebber@ebber.com', nb: 'ebber@ebber.com' }[language],
    },
  ]

  return variables
}

export const SENDER_FIELD = 'sender'
export const SUBJECT_FIELD = 'subject'
export const MESSAGE_FIELD = 'message'

export const getDefaultValues = () => ({
  [SENDER_FIELD]: '',
  [SUBJECT_FIELD]: '',
  [MESSAGE_FIELD]: null,
})
